export default "__VITE_ASSET__d32c262e__"